import React from 'react';

import Grid from '@material-ui/core/Grid';

import DashboardLayout from './../../layouts/dashboard';
import { PassengersCreate } from './../../../components/Passengers/PassengersCreate';

export const PassengerCreatePage = () => {
  return (
    <DashboardLayout title={'Pasajeros'}>
      <Grid
        container
        spacing={0}
        direction="row"
        alignItems="flex-start"
        justifyContent="flex-start"
        style={{ minHeight: '100vh' }}
      >
        <Grid item xs>
          <PassengersCreate />
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};
